import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  return (
    <>
      <div className="content-wrapper">
        <aside>
          <div className="profile-img-wrapper">
            <img src="assets/images/Profile.tiff" alt="profile" />
          </div>
          <h1 className="profile-name">Rujiravee Kongdee</h1>
          <div className="text-center">
            <span className="badge badge-primary badge-pill profile-designation">
              Postgraduate researcher
            </span>
          </div>
          <div className="widget">
            <h5 className="widget-title">personal information</h5>
            <div className="widget-content">
              <p>ORCID: <br/><a href="https://orcid.org/0000-0003-0375-2833">https://orcid.org/0000-0003-0375-2833</a></p>
              <p>PHONE: <br/>+44 7824581600</p>
              <p>E-MAIL: <br/>rujiraveekongdee@gmail.com</p>
            </div>
          </div>
          <div className="widget card">
            <div className="card-body">
              <div className="widget-content">
                <h5 className="widget-title card-title">INTERESTS</h5>
                <p>Human-Computer Interaction</p>
                <p>UI/UX design</p>
                <p>Bacon 🥓</p>
              </div>
            </div>
          </div>
        </aside>

        <main>
          <section className="intro-section">
            <h2 className="section-title">Hello, world!</h2>
            <p className="text-black">
              Hi! My name is Rujiravee Kongdee, or you can call me Vee. I'm from
              Thailand. I have been awarded Royal Thai Government scholarship
              and I'm currently a postgraduate researcher at The University of
              Manchester, United Kingdom. I'm a member of the Interaction
              Analysis and Modelling Lab (IAM Lab)
            </p>
          </section>
          <section className="resume-section text-black">
            <div className="row">
              <div className="col-lg-6">
                <h2 className="section-title">Experience</h2>
                <ul className="time-line">
                  <li className="time-line-item">
                    <span className="badge badge-primary">
                      January – March 2020
                    </span>
                    <h6 className="time-line-item-title">
                      LECTURER AND TEACHER ASSISTANT
                    </h6>
                    <p className="time-line-item-subtitle">
                      Nakhon Pathom Rajabhat University, Thailand
                    </p>
                    <p className="time-line-item-content">
                      <ul>
                        <li>
                          Teaching Introduction to Software Engineering as well
                          as assist in the development of learning materials and
                          developing exams
                        </li>
                        <li>
                          Assist with teaching of Database System, Human
                          Computer Interaction and English for Computer courses
                        </li>
                        <li>Guest Lecturer for UI UX Workshop</li>
                      </ul>
                    </p>
                  </li>
                  <li className="time-line-item">
                    <span className="badge badge-primary">
                      June - November 2018
                    </span>
                    <h6 className="time-line-item-title">
                      SOFTWARE ENGINEER - INTERN
                    </h6>
                    <p className="time-line-item-subtitle">
                      Thomson Reuters Software Thailand, Bangkok, Thailand
                    </p>
                    <p className="time-line-item-content">
                      <ul>
                        <li>
                          Responsible for improving security of Thomson Reuter’s
                          most important and largest application: Eikon. Coding
                          in the part of web application, service and database.
                          And deployed to all server of the company across the
                          world
                        </li>
                        <li>
                          Responsible for a project of creating a software
                          framework to improve the usability for users which
                          will be implemented in the software product of the
                          company
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li className="time-line-item">
                    <span className="badge badge-primary">
                      June 2017 - July 2017
                    </span>
                    <h6 className="time-line-item-title">Intern</h6>
                    <p className="time-line-item-subtitle">
                      Stockradars Application, Siam Squared Technology, Bangkok,
                      Thailand
                    </p>
                    <p className="time-line-item-content">
                      <ul>
                        <li>
                          Assigned for editing front-end page of the website
                          using HTML, CSS, PHP, Javascript and Angular framework
                        </li>
                        <li>
                          Developed data gathering system for retrieving data
                          from Facebook Graph API to the company’s database
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li className="time-line-item">
                    <span className="badge badge-primary">
                      December 2016 - April 2017
                    </span>
                    <h6 className="time-line-item-title">
                      HEAD OF IT DEPARTMENT
                    </h6>
                    <p className="time-line-item-subtitle">
                      TEDxKMITL, Bangkok, Thailand
                    </p>
                    <p className="time-line-item-content">
                      <ul>
                        <li>
                          Managed and assigned the staff members to create a
                          website for promoting TEDxKMITL
                        </li>
                        <li>
                          Coordinated across different teams in order to design
                          workflow and developed the project plan of the
                          organization.
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li className="time-line-item">
                    <span className="badge badge-primary">December 2016</span>
                    <h6 className="time-line-item-title">
                      FRONT-END WEB DEVELOPER
                    </h6>
                    <p className="time-line-item-subtitle">
                      CE Smart Camp 10th, Department of Computer Engineering,
                      KMITL, Thailand
                    </p>
                    <p className="time-line-item-content">
                      <ul>
                        <li>
                          Responsible for developing and maintaining the website
                          for the camp, www.cesmartcamp.com, support any devices
                          by responsive design.
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li className="time-line-item">
                    <span className="badge badge-primary">August 2016</span>
                    <h6 className="time-line-item-title">
                      CHIEF OF STAFF AND COORDINATOR
                    </h6>
                    <p className="time-line-item-subtitle">
                      CE Boost Up 4th, Department of Computer Engineering,
                      KMITL, Thailand
                    </p>
                    <p className="time-line-item-content">
                      <ul>
                        <li>
                          Responsible for managing all activities across the
                          camp
                        </li>
                        <li>
                          Coordinated with students, academic staff and external
                          clients on activity initiation
                        </li>
                      </ul>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <h2 className="section-title">EDUCATION</h2>
                <ul className="time-line">
                  <li className="time-line-item">
                    <span className="badge badge-primary">2021 - Now</span>
                    <h6 className="time-line-item-title">
                      DOCTOR OF PHILOSOPHY IN COMPUTER SCIENCE
                    </h6>
                    <p className="time-line-item-subtitle">
                      The University of Manchester, United Kingdom
                    </p>
                    <p className="time-line-item-content">
                      <b>Thesis title:</b> Type 1 Diabetes: Zero Interpretation
                      Feedback and Algorithmic Explainability <br />
                      <b>Aims:</b> To create a system which directs type 1
                      diabetes patients to perform certain actions to maintain
                      safe glycemic level without the need to interpret
                      graphical or numerical data. The system also provides
                      rationale behind the algorithm's decision, or algorithmic
                      explainability.
                    </p>
                  </li>
                  <li className="time-line-item">
                    <span className="badge badge-primary">2020 - 2021</span>
                    <h6 className="time-line-item-title">
                      MASTER OF ADVANCED COMPUTER SCIENCE (Distinction)
                    </h6>
                    <p className="time-line-item-subtitle">
                      The University of Manchester, United Kingdom
                    </p>
                    <p className="time-line-item-content">
                      Specialisation in Software Engineering
                    </p>
                    <p className="time-line-item-content">
                      <b>Master's dissertation:</b> Type 1 Diabetes: Insulin
                      Sensitivity Prediction <br />
                      <b>Aims:</b> To build prediction models to predict insulin
                      sensitivity of type 1 diabetes patients by comparing the
                      model's performance produced by various machine learning
                      algorithms and identify the most suitable algorithm for
                      individuals.
                    </p>
                  </li>
                  <li className="time-line-item">
                    <span className="badge badge-primary">2014 - 2018</span>
                    <h6 className="time-line-item-title">
                      BACHELOR OF ENGINEERING MAJOR IN COMPUTER ENGINEERING
                    </h6>
                    <p className="time-line-item-subtitle">
                      King Mongkut’s Institute of Technology Ladkrabang,
                      Bangkok, Thailand
                    </p>
                    <p className="time-line-item-content">
                      Graduated with Second class honours
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
}

export default App;
